<div id="selection-title">
  {{content.metaData.fullTitle}}
</div>

<div [ngClass]="content.classes" [ngStyle]="selectionStyle" id="selection-content">
    <div  *ngFor="let t of content.text"
          [ngClass]="t.classes"
          id="{{ t.id }}">

          <span *ngFor="let s of t.sentences"
                [ngClass]="s.classes"
                id="{{ s.id }}">
              <ng-container *ngFor="let w of s.words">
                <span class="word-punctuation-wrapper" [ngClass]="w.classes">
                  <span (click)="selectWord(w);">
                      <span class="prefix">{{w.prefix}}</span>
                      <span class="word-span">{{w.word}}</span>
                      <span>{{w.separatorPunctuation}}</span>
                  </span>
                  <span
                      *ngIf="w.questionId"
                      class="tai"
                      [ngClass]="getTAIQuestionState(w.questionId)"
                      (click)="selectTAI(w.questionId)">&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                <span>{{w.separatorTrailingWhiteSpace}}</span>
              </ng-container>
          </span>

          <img *ngIf="t.type === 'image'"
               (click)="selectImage(t)" src="{{ getImageURL(t.mediaFormat.source) }}" />

          <div *ngIf="t.type === 'image' && !!t.mediaFormat.caption" class="caption">
              {{t.mediaFormat.caption}}
          </div>
    </div>
</div>

<div class="recording-scroll-arrow do-flash"
     *ngIf="scrollArrow"
     (click)="scrollArrowClickedEvent()">
    <div class="arrow"></div>
</div>
